module.exports = __webpack_public_path__ + "img/info.9ad1d94c.png";